import {Base} from "@/api/Base"

export class UploadRecordList extends Base {
    path = "uploadRecord/list"
}